import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {usePaymentIntents} from '../hooks/usePaymentIntents.ts';

export const ReloadRecordsButton = () => {

    const {fetchRecords} = usePaymentIntents();
    return (
        <Box mx='s'>
            <ReloadButton onClick={() => fetchRecords()}/>
        </Box>
    );
};
